import { MANUAL, AUTOMATIC, SEMI_AUTOMATIC, DUPLEX } from './values';
import prepareOptions from '../../prepareOptions';

export default prepareOptions([
  {
    label: __('carDetails.gearType.manual'),
    value: MANUAL,
  },
  {
    label: __('carDetails.gearType.automatic'),
    value: AUTOMATIC,
  },
  {
    label: __('carDetails.gearType.semiAautomatic'),
    value: SEMI_AUTOMATIC,
  },
  {
    label: __('carDetails.gearType.duplex'),
    value: DUPLEX,
  },
]);
